import authorizedLocation from './authorizedLocations';

const isAuthForLocation = (
  user: { location: string; locations?: string[] },
  listing: { location?: string | number; locations?: string[] },
) => {
  const listingLocations = Array.from(
    new Set([listing.location?.toString(), ...(listing.locations || [])]),
  ).filter(Boolean);

  const userAuthorizedLocations = authorizedLocation(user);

  return listingLocations.some((location: string) =>
    userAuthorizedLocations.includes(location),
  );
};

export default isAuthForLocation;
